import React from "react";
import { string, bool, func } from "prop-types";
import { useTranslation } from "@lib/i18n";

import ProgressBar from "../progressBar/ProgressBar";
import ContentContainer from "./ContentContainer";
import Address from "../Address";
import SimpleButton from "@components/shared/SimpleButton";

import { useTestDrivePointSelector } from "@redux/reducers/testDrive";

const InitialLocationStep = ({
  progressBarColor,
  selectionName,
  withEditButton,
  editAction,
  isHomeTestDrive,
}) => {
  const locationData = useTestDrivePointSelector();
  const { t } = useTranslation();

  return (
    <section className="flex justify-start items-stretch w-full">
      <ProgressBar
        isInitialStep
        isComplete
        progressBarColor={progressBarColor}
        isHomeTestDrive={isHomeTestDrive}
      />
      <ContentContainer
        title={selectionName}
        progressBarColor={progressBarColor}
        data-id="test-drive-location-data"
      >
        {locationData && (
          <Address
            address1={locationData.address1}
            address2={locationData.address2}
            city={locationData.city}
            country={locationData.countryName}
            zipcode={locationData.zipcode}
          />
        )}
        {withEditButton && (
          <SimpleButton className="p-0 m-0" onClick={editAction} withArrow>
            {t("general.modify")}
          </SimpleButton>
        )}
      </ContentContainer>
    </section>
  );
};

InitialLocationStep.propTypes = {
  progressBarColor: string,
  selectionName: string.isRequired,
  withEditButton: bool,
  editAction: func,
  isHomeTestDrive: bool,
};

export default InitialLocationStep;
